import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_WORKSPACE_BIDDERS: TypedDocumentNode<Data, Variables> = gql`
  query getWorkspaceBidders($workspaceId: ID!, $sort: WorkspaceBidderSortInput) {
    workspaceBidders(workspaceId: $workspaceId, sort: $sort) {
      nodes {
        id
        bidderCode
      }
    }
  }
`
